import React, { useState } from 'react';

export const ModalContext = React.createContext();

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [componentType, setComponentType] = useState();
  const [componentProps, setComponentProps] = useState();
  const [options, setOptions] = useState({});

  const openModal = (event, type, props, options) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsOpen(true);
    setComponentType(type);
    setComponentProps(props);
    setOptions(options);

    console.log('opening modal');
    console.log(props);
  };

  const closeModal = () => {
    setIsOpen(false);
    setComponentType(null);
    setComponentProps(null);
    setOptions({});
  };

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        componentType,
        componentProps,
        options,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const withModal = Component => props => (
  <ModalContext.Consumer>
    {context => <Component {...props} modalContext={context} />}
  </ModalContext.Consumer>
);
